import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import MobileProducts from "@/pages/MobileProducts";
import ProductGridPrint from "@/pages/ProductGridPrint";
import Settings from "@/pages/Settings";
import Cart from "@/pages/Cart";
import CartLabelsPrint from "@/pages/CartLabelsPrint";
import CartGridPrint from "@/pages/CartGridPrint";
import Customers from "@/pages/Customers";
import QuotePage from "@/pages/QuotePage";
import BestSellingPrint from "@/pages/BestSellingPrint";
import GTSellingHistory from "@/pages/GTSellingHistory";
import GTSellingHistoryPrint from "@/pages/GTSellingHistoryPrint";
import BHSellingHistory from "@/pages/BHSellingHistory";
import MobileCart from "@/pages/MobileCart";
import Help from "@/pages/Help";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ErrorBoundary>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/quote/:token" element={<QuotePage />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mobile"
                element={
                  <ProtectedRoute>
                    <MobileProducts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/products/print"
                element={
                  <ProtectedRoute>
                    <ProductGridPrint />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute allowedRoles={["admin", "office"]}>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route path="/users" element={<Navigate to="/settings?tab=users" replace />} />
              <Route
                path="/help"
                element={
                  <ProtectedRoute>
                    <Help />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mobile/cart"
                element={
                  <ProtectedRoute>
                    <MobileCart />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customers"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <Customers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cart"
                element={
                  <ProtectedRoute>
                    <Cart />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cart/grid-print"
                element={
                  <ProtectedRoute>
                    <CartGridPrint />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cart/labels"
                element={
                  <ProtectedRoute>
                    <CartLabelsPrint />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/gt-selling-history"
                element={
                  <ProtectedRoute>
                    <GTSellingHistory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/gt-selling-history/print"
                element={
                  <ProtectedRoute>
                    <GTSellingHistoryPrint />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/bh-selling-history"
                element={
                  <ProtectedRoute allowedRoles={["admin", "office"]}>
                    <BHSellingHistory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/best-selling/print"
                element={
                  <ProtectedRoute>
                    <BestSellingPrint />
                  </ProtectedRoute>
                }
              />
              <Route path="/carts" element={<Navigate to="/cart" replace />} />
            </Routes>
          </ErrorBoundary>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;

